import CONTACT_STATES from 'lib/common/constants/contactStates';

import getTaskType from './getTaskType';

export default function handlePendingPreviewDialingTask(handleContactChange) {
  return (latestContact) => {
    if (getTaskType(latestContact) !== 'PREVIEW_DIALING') {
      return;
    }

    handleContactChange({
      contact: latestContact,
      status: CONTACT_STATES.PENDING,
      eventTimestamp: Date.now(),
    });
  };
}
